import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
//import RemoveCircle from 'material-ui/svg-icons/content/remove-circle';


export default (props) => {

  return (
    <RaisedButton 
      disabled={props.pending} 
      onTouchTap={props.onTouchTap}  
      primary={props.primary}
      label={props.label}
 />
  );
}



// WEBPACK FOOTER //
// ./src/components/Buttons/ButtonAsync.jsx